import { Col, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import {
  ColumnComponent,
  ContainerComponent
} from "../../../components";
import { SuccessUseCasePartial } from "../partials/success-usecase.partial";
import VideoCard from "../partials/video-card.partial";

export const WelcomeView = () => {
  /* const {
    token: { colorBgContainer },
  } = theme.useToken(); */
  return (
    <ColumnComponent align={"start"}>
      <Typography.Title level={2} style={{ color: 'var(--color-primary)' }}>
        Bienvenido a Sharksia Gen Studio
      </Typography.Title>

      <ContainerComponent
        style={{
          padding: 0,
          width: "100%",
          borderRadius: 16,
        }}
      >
        <ColumnComponent>
          <ContainerComponent
            style={{
              textAlign: "left",
              position: "relative",
              padding: 0,
              borderRadius: 16,
              background: "linear-gradient(90deg, #4318FF, #9747FF)",
              backgroundColor: "var(--color-primary)",
              overflow: "hidden",
              width: "100%",
              height: "50vh",
            }}
          >
            <Row style={{ height: "100%", position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "10%",
                  zIndex: 10,
                  color: "white",
                  textAlign: "left",
                  pointerEvents: "none",
                }}
              >
                <Typography.Title level={2} style={{ color: "white", marginBottom: 8 }}>
                  Somos Sharksia
                </Typography.Title>
                <Typography.Text style={{ display: "block", color: "white", fontSize: 16 }}>
                  Un ecosistema inteligente para la gestión y
                </Typography.Text>
                <Typography.Text style={{ display: "block", color: "white", fontSize: 16 }}>
                  optimización de procesos con Agentes AGA
                </Typography.Text>

                <div style={{ marginTop: 24, display: "flex", gap: 12, flexWrap: "wrap" }}>
                  <button
                    style={{
                      backgroundColor: "#ffffff",
                      color: "var(--color-primary)",
                      border: "1px solid var(--color-primary)",
                      borderRadius: 8,
                      padding: "8px 16px",
                      cursor: "pointer",
                      pointerEvents: "auto",
                    }}
                  >
                    Descubre ahora
                  </button>
                  <button
                    style={{
                      backgroundColor: "transparent",
                      color: "#ffffff",
                      border: "1px solid #ffffff",
                      borderRadius: 8,
                      padding: "8px 16px",
                      cursor: "pointer",
                      pointerEvents: "auto",
                    }}
                  >
                    Ver videos
                  </button>
                </div>
              </div>

              <Col xs={14} sm={14} md={14} lg={14} style={{ position: "relative", zIndex: 1 }}>
                <img
                  src="/home-images-container/smook-effect.gif"
                  alt="Imagen 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Col>

              <Col
                xs={10}
                sm={10}
                md={10}
                lg={10}
                style={{
                  position: "relative",
                  overflow: "visible",
                }}
              >
                <img
                  src="/home-images-container/imagen1.png"
                  alt="Imagen 2"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "70%",
                    transform: "translate(-50%, -50%) rotate(65deg) scaleX(-1)",
                    transformOrigin: "center",
                    width: "180%",
                    height: "auto",
                    objectFit: "contain",
                    zIndex: 2,
                    opacity: 0.9,
                  }}
                />
              </Col>

              <style>
                {`
                  @media (max-width: 700px) {
                    img[alt="Imagen 2"] {
                      width: 250%;
                      transform: translate(-50%, -50%) rotate(65deg) scaleX(-1);
                    }
                  }
                `}
              </style>
            </Row>
          </ContainerComponent>

          <ColumnComponent style={{ marginTop: "3%" }}>
            <Typography.Title level={4} style={{ color: "var(--color-primary)", alignSelf: "start" }}>
              Últimos casos de uso exitosos
            </Typography.Title>
          </ColumnComponent>

          <ColumnComponent style={{ marginTop: "1%", alignItems: "start" }}>
            <Row gutter={[16, 16]} justify="start" align="stretch">
              {[
                { id: "67f6b9fc765650002774f0f4", title: "Optimizador de agendas", imageSrc: "https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/62a82b07-086c-4484-89c1-22f4def78d5f.png" },
                { id: "67eafd7f704a1f607aea54e8", title: "Arrime", imageSrc: "https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/f93a3073-6e1a-4213-9a63-d165e722d969.jpg" },
                { id: "67f6a2c9765650002774f0f3", title: "Alertamiento por valores anómalos en LOGS", imageSrc: "https://devagentesinteligentes.blob.core.windows.net/agentes-catalogo/ade029aa-6524-406e-b10c-6286fcadc1d7.jpg" },
              ].map((usecase) => (
                <Col
                  key={usecase.id}
                  xs={24}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{ display: "flex", alignItems: "stretch" }}
                >
                  <Link
                    to={`/usecases/${usecase.id}`}
                    style={{
                      display: "flex",
                      width: "100%",
                    }}
                  >
                    <SuccessUseCasePartial
                      key={usecase.id}
                      title={usecase.title}
                      imageSrc={usecase.imageSrc}
                    />
                  </Link>
                </Col>
              ))}
            </Row>
          </ColumnComponent>

          <ColumnComponent style={{ marginTop: "3%" }}>
            <Typography.Title level={4} style={{ color: "var(--color-primary)", alignSelf: "start" }}>
              Videos introductorios de Sharksia Gen Studio
            </Typography.Title>
          </ColumnComponent>

          <ColumnComponent style={{ marginTop: "1%", alignItems: "start" }}>
            <Row gutter={[16, 16]} justify="start" align="stretch">
              {[
                //{ id: 1, title: "Sharksia - Punto de vista MAGSs", description: "Descripción del video 1", urlVideo: "/hardcoded/what_is_inteligent_agents.mp4" },
                { id: 1, title: "Sharksia - Presentación coorporativa", description: "Descripción del video 1", urlVideo: "/hardcoded/SHARKSIA - PRESENTACION CORPORATIVA - 23-MAYO-25 V4.mp4" },
                { id: 2, title: "Sharksia - Punto de vista MAGSs", description: "Descripción del video 2", urlVideo: "/hardcoded/SHARKS IA_- Presentacion Corporativa AGAs - 23-MAY-25 v3.0 - Briefing McS.mp4" }
              ].map((video) => (
                <Col
                  key={video.id}
                  xs={24}
                  sm={14}
                  md={10}
                  lg={6}
                  style={{ display: "flex" }}
                >
                  <VideoCard
                    key={video.id}
                    title={video.title}
                    description={video.description}
                    urlVideo={video.urlVideo}
                    preload="metadata"
                    poster="/hardcoded/professional_service.jpeg"
                  />
                </Col>
              ))}
            </Row>
          </ColumnComponent>

        </ColumnComponent>
      </ContainerComponent>
    </ColumnComponent>
  );
};

export const WelcomeRoute = "/";
